// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .sidebar {
      width: 250px;
      transition: all 0.3s ease;
      position: relative;
      z-index: 1030;
    }

    .sidebar-collapsed {
      width: 80px;
    }

    @media (max-width: 767.98px) {
      .sidebar {
        position: fixed;
        top: 0;
        left: -250px;
        height: 100vh !important;
        box-shadow: none;
      }

      .sidebar-mobile {
        width: 280px;
      }

      .sidebar-mobile-open {
        left: 0;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
      }

      .sidebar-collapsed {
        left: -280px;
      }
    }
  `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/sections/zikata-sidebar/zikata-sidebar.component.ts"],"names":[],"mappings":";IACI;MACE,YAAY;MACZ,yBAAyB;MACzB,kBAAkB;MAClB,aAAa;IACf;;IAEA;MACE,WAAW;IACb;;IAEA;MACE;QACE,eAAe;QACf,MAAM;QACN,YAAY;QACZ,wBAAwB;QACxB,gBAAgB;MAClB;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,OAAO;QACP,6CAA6C;MAC/C;;MAEA;QACE,YAAY;MACd;IACF","sourcesContent":["\n    .sidebar {\n      width: 250px;\n      transition: all 0.3s ease;\n      position: relative;\n      z-index: 1030;\n    }\n\n    .sidebar-collapsed {\n      width: 80px;\n    }\n\n    @media (max-width: 767.98px) {\n      .sidebar {\n        position: fixed;\n        top: 0;\n        left: -250px;\n        height: 100vh !important;\n        box-shadow: none;\n      }\n\n      .sidebar-mobile {\n        width: 280px;\n      }\n\n      .sidebar-mobile-open {\n        left: 0;\n        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n      }\n\n      .sidebar-collapsed {\n        left: -280px;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
